import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  location: string;
  image: string;
  delay?: number;
}
export function TestimonialCard({
  quote,
  name,
  location,
  image,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-[#F7F4EF] p-8 rounded-xl relative flex flex-col h-full border border-[#E6D3B3]/30" data-id="element-516" data-mp="2p8q6oeu0zkt4">
      <div className="w-10 h-10 rounded-full bg-white border-2 border-[#E6D3B3] flex items-center justify-center mb-6 shadow-sm" data-id="element-517" data-mp="386ao50ugnh3p">
        <Quote className="w-5 h-5 text-[#C9A961]" strokeWidth={1.75} data-id="element-518" data-mp="19rzjb3b4c3or" />
      </div>

      <p className="text-[#2E2E2E] text-lg leading-relaxed italic mb-6 flex-grow" data-id="element-519" data-mp="1ds00gvplqszi">
        "{quote}"
      </p>

      <div className="flex items-center mt-auto" data-id="element-520" data-mp="htw4vkjfy89z">
        <img src={image} alt={name} className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-white shadow-sm" data-id="element-521" data-mp="hunri5v28vo4" />
        <div data-id="element-522" data-mp="83t3ox261o0k">
          <h4 className="font-semibold text-[#2E2E2E]" data-id="element-523" data-mp="83ayhaxizzgi">{name}</h4>
          <p className="text-sm text-[#888888]" data-id="element-524" data-mp="34pz1dq3ljt4">{location}</p>
        </div>
      </div>
    </motion.div>;
}